import { Shield, Home, TrendingUp, Clock, CheckCircle, PoundSterling } from "lucide-react";
import { useState } from "react";
import GuaranteedRentClosedModal from "./GuaranteedRentClosedModal";

const cards = [
  { Icon: Shield, title: "Guaranteed income", description: "Fixed monthly income paid on the same date, every month — whether the property is occupied or not." },
  { Icon: Home, title: "We become your tenant", description: "We take a long-term lease on your property, operate it as serviced accommodation, and deal with everything in between." },
  { Icon: TrendingUp, title: "No voids, ever", description: "Empty nights are our problem, not yours. You receive the same payment regardless of occupancy." },
  { Icon: Clock, title: "Property care included", description: "Cleaning, maintenance, and wear-and-tear repairs are all handled by our team at no extra cost to you." },
  { Icon: CheckCircle, title: "Optional refurbishment", description: "Subject to agreement, we may carry out light refurbishments to improve the property — funded by us, approved by you." },
  { Icon: PoundSterling, title: "No tenant risk", description: "No arrears, no evictions, no deposit disputes. We are your tenant — a professional company on a fixed-income contract." },
];

const DEFAULT_ACTIVE = 1;

export default function GuaranteedRentBenefits() {
  const [activeIndex, setActiveIndex] = useState(DEFAULT_ACTIVE);
  const [showModal, setShowModal] = useState(false);

  return (
    <section style={{ backgroundColor: "#fff", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 12, marginTop: 0 }}>
            The Benefits
          </p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 44px)", letterSpacing: "-0.02em", lineHeight: 1.15, color: "#112215", margin: "0 auto 14px", maxWidth: 640 }}>
            Why choose guaranteed rent?
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, color: "#5C7268", lineHeight: 1.6, maxWidth: 540, margin: "0 auto" }}>
            We operate your property as serviced accommodation and pay you a fixed monthly income — with zero void risk, zero tenant hassle, and full property care included.
          </p>
        </div>

        <div className="gr-benefits-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14 }}>
          {cards.map(({ Icon, title, description }, i) => {
            const isActive = activeIndex === i;
            return (
              <div
                key={title}
                onClick={() => setShowModal(true)}
                onMouseEnter={() => setActiveIndex(i)}
                style={{
                  background: isActive ? "#112215" : "#F4F1E7",
                  borderRadius: 14,
                  padding: "26px 26px 30px",
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  transform: isActive ? "rotate(-1.5deg) scale(1.03)" : "rotate(0deg) scale(1)",
                  boxShadow: isActive ? "0 20px 50px rgba(0,0,0,0.22)" : "0 0 0 rgba(0,0,0,0)",
                  transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
                  zIndex: isActive ? 2 : 1,
                  position: "relative",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 44 }}>
                  <span style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 16, color: isActive ? "#fff" : "#112215", letterSpacing: "-0.01em", transition: "color 0.25s" }}>
                    {title}
                  </span>
                  <div style={{ width: 34, height: 34, borderRadius: 9, background: isActive ? "rgba(255,255,255,0.15)" : "#EDE9DC", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "background 0.25s" }}>
                    <Icon size={16} color={isActive ? "#fff" : "#5C7268"} strokeWidth={1.8} />
                  </div>
                </div>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13.5, color: isActive ? "rgba(255,255,255,0.75)" : "#5C7268", lineHeight: 1.65, margin: 0, transition: "color 0.25s" }}>
                  {description}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {showModal && <GuaranteedRentClosedModal onClose={() => setShowModal(false)} />}

      <style>{`
        @media (max-width: 900px) { .gr-benefits-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 560px) { .gr-benefits-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}